import React, { useMemo } from 'react';
import { useI18n } from '../../hooks/useI18n';
import creatureImage from '../../assets/Kimeracreatura.png';
import RedSquare from '../RedSquare/RedSquare';
import { FooterContactInfo } from './Footer.types';
import { FOOTER_CONTACT, FOOTER_ACCESSIBILITY } from './Footer.constants';
import {
  StyledFooter,
  FooterContent,
  StyledFlex,
  FooterCreature,
  FooterCreatureImg,
  FooterContactInfo as FooterContactInfoContainer,
  FooterContactText,
  FooterEmail,
  FooterCopyright,
} from './Footer.styles';

const Footer: React.FC = React.memo(() => {
  const { t } = useI18n();

  const contactInfo: FooterContactInfo = useMemo(
    () => ({
      email: FOOTER_CONTACT.EMAIL,
      contactText: t('footer.contact'),
      copyrightText: t('footer.copyright'),
    }),
    [t],
  );

  const handleEmailClick = (event: React.MouseEvent): void => {
    event.preventDefault();
    window.open(`mailto:${contactInfo.email}`, '_blank');
  };

  const handleEmailKeyDown = (event: React.KeyboardEvent): void => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      window.open(`mailto:${contactInfo.email}`, '_blank');
    }
  };

  return (
    <StyledFooter role={FOOTER_ACCESSIBILITY.FOOTER_REGION}>
      <FooterContent>
        <StyledFlex justify="center" align="center">
          <FooterCreature>
            <FooterCreatureImg
              src={creatureImage}
              alt={t('footer.creatureAlt')}
              aria-label={t('footer.creatureAlt')}
            />
          </FooterCreature>

          <FooterContactInfoContainer>
            <FooterContactText>
              {contactInfo.contactText}
              <RedSquare size="medium" />
            </FooterContactText>

            <FooterEmail
              href={`mailto:${contactInfo.email}`}
              onClick={handleEmailClick}
              onKeyDown={handleEmailKeyDown}
              role={FOOTER_ACCESSIBILITY.EMAIL_LINK_ROLE}
              tabIndex={0}
              aria-label={`${t('accessibility.sendEmailTo')} ${contactInfo.email}`}
            >
              {contactInfo.email}
            </FooterEmail>
          </FooterContactInfoContainer>
        </StyledFlex>

        <FooterCopyright>{contactInfo.copyrightText}</FooterCopyright>
      </FooterContent>
    </StyledFooter>
  );
});

Footer.displayName = 'Footer';

export default Footer;
